<hx-dialog [title]="'Column Customization'">
  <div hxDialogContent>
    <div class="hx-column-customization__list">
      <!-- Select All Option -->
      <div class="hx-column-customization__item hx-column-customization__item--select-all">
        <hx-checkbox
          class="hx-column-customization__checkbox"
          [options]="[
            {
              label: 'Select All',
              value: 'select-all',
            },
          ]"
          [selectedValues]="isSelectAllChecked() ? ['select-all'] : []"
          (selectedValuesChange)="handleSelectAllChange($event)" />
      </div>

      <!-- Individual Columns -->
      @for (column of columns(); track column.field) {
        <div class="hx-column-customization__item">
          <hx-checkbox
            class="hx-column-customization__checkbox"
            [options]="[
              {
                label: column.header,
                value: column.field,
              },
            ]"
            [selectedValues]="isColumnSelected(column.field) ? [column.field] : []"
            (selectedValuesChange)="handleColumnCheckboxChange(column.field, $event)" />
        </div>
      }
    </div>
  </div>

  <div hxDialogActions>
    <div class="hx-column-customization__footer">
      <button hxButton type="reset" [size]="'sm'" [variant]="'outline'" (click)="resetColumns()">
        <i class="ccs ccs-arrow-counterclockwise"></i>
        Reset
      </button>

      <div class="hx-column-customization__footer-actions">
        <button hxButton type="button" [size]="'sm'" [variant]="'outline'" (click)="cancel()">Cancel</button>
        <button hxButton type="button" [size]="'sm'" [variant]="'fill'" (click)="applyChanges()">Done</button>
      </div>
    </div>
  </div>
</hx-dialog>
